import { axiosInstance } from "@/helper/axios-instance";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

type Args = {
  id: string;
  fileName: string;
};

type SuccessData = {
  response: AxiosResponse<any>;
  fileName: string;
};

export function useDownloadDocumentTemplate() {
  return useMutation({
    mutationFn: async ({ id, fileName }: Args) => {
      const response = await axiosInstance({
        method: "GET",
        url:  `DocumentTemplate/Download/${id}`,
      });

      return { response, fileName };
    },
    onSuccess: (data: SuccessData) => {
      const { response, fileName } = data;

      const link = document.createElement("a");
      link.href =
        "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," +
        response.data;

      link.download = fileName;
      link.click();
    },
  });
}
